import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JsonInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Skip if body is FormData (file uploads must not be JSON)
    if (req.body instanceof FormData) {
      return next.handle(req);
    }

    const jsonReq = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: req.body && typeof req.body === 'object'
        ? JSON.stringify(req.body)
        : req.body
    });

    return next.handle(jsonReq);
  }
}
